export class PaymentMethodResponse
{
    public readonly hasPaymentMethod:boolean;
    public readonly cardType:any;
    public readonly cardFirst6:string;
    public readonly cardLast4:string;

    constructor(json:any)
    {
        this.hasPaymentMethod = json['hasPaymentMethod'];
        this.cardType = json['cardType'];
        this.cardFirst6 = json['cardFirst6'];
        this.cardLast4 = json['cardLast4'];
    }
}
